import type { Handle, HandlePosition, Point } from '../state/types';

export const getHandleAtPoint = (
  handles: Handle[],
  point: Point,
  threshold: number
): HandlePosition | null => {
  for (const handle of handles) {
    const dist = Math.hypot(point.x - handle.point.x, point.y - handle.point.y);
    if (dist <= threshold) {
      return handle.position;
    }
  }
  return null;
};

const HANDLE_CURSORS: Record<HandlePosition, string> = {
  'top-left': 'nwse-resize',
  top: 'ns-resize',
  'top-right': 'nesw-resize',
  right: 'ew-resize',
  'bottom-right': 'nwse-resize',
  bottom: 'ns-resize',
  'bottom-left': 'nesw-resize',
  left: 'ew-resize',
};

export const getResizeCursor = (handle: HandlePosition): string =>
  HANDLE_CURSORS[handle] ?? 'default';
